import styled from 'styled-components';

// 模态框和通知组件
export const ConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  
  .modal-content {
    background: white;
    border-radius: 16px;
    padding: 32px;
    max-width: 480px;
    width: 90%;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    position: relative;
    
    .close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 6px;
      border-radius: 6px;
      color: #6b7280;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &:hover {
        background: #f3f4f6;
        color: #374151;
      }
    }
    
    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0 0 16px 0;
      padding-right: 32px;
      display: flex;
      align-items: center;
      gap: 12px;
      
      svg {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        color: #f59e0b;
        stroke-width: 2;
      }
    }
    
    p {
      color: #6c757d;
      margin: 0 0 24px 0;
      line-height: 1.5;
      font-size: 14px;
    }
    
    .button-group {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
      
      button {
        padding: 10px 20px;
        border-radius: 8px;
        border: none;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 14px;
        
        &.cancel {
          background: #f8f9fa;
          color: #495057;
          border: 1px solid #e9ecef;
          
          &:hover {
            background: #e9ecef;
          }
        }
        
        &.confirm {
          background: #dc3545;
          color: white;
          
          &:hover {
            background: #c82333;
          }
        }
      }
    }
  }
`;

export const NegativeWordsModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  
  .modal-content {
    background: white;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow: hidden; /* 确保内容遵循圆角裁切，但不允许整体滚动 */
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
    
    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 24px 16px 24px;
      border-bottom: 1px solid #e5e7eb;
      flex-shrink: 0; /* 防止标题区域被压缩 */
      
      h3 {
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
        margin: 0;
      }
      
      .close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: #f3f4f6;
        border: none;
        border-radius: 6px;
        font-size: 18px;
        color: #6c757d;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
          background: #e5e7eb;
          color: #111827;
        }
      }
    }
    
    .words-list {
      flex: 1;
      overflow-y: auto;
      padding: 16px 24px 24px 24px;
      overscroll-behavior: contain; /* 阻止滚动穿透 */
      scrollbar-width: thin; /* Firefox */
      scrollbar-color: rgba(0,0,0,0.28) transparent;

      /* WebKit 滚动条样式 */
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.25);
        border-radius: 8px;
        border: 2px solid transparent;
        background-clip: content-box;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0,0,0,0.35);
      }
      
      display: flex;
      flex-direction: column;
      gap: 16px;
      
      .word-item {
        padding: 16px;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        background: #ffffff;
        box-shadow: 0 1px 0 rgba(17, 24, 39, 0.04);
        
        .word-title {
          font-size: 14px;
          font-weight: 600;
          color: #dc2626;
          margin-bottom: 8px;
        }
        
        .word-context {
          font-size: 13px;
          color: #6c757d;
          margin-bottom: 8px;
          font-style: italic;
        }
        
        .word-suggestion {
          font-size: 13px;
          color: #16a34a;
          font-weight: 500;
          
          &::before {
            content: '💡 建议：';
            margin-right: 4px;
          }
        }
      }
    }
  }
`;

export const ToastNotification = styled.div`
  position: fixed;
  top: 80px;
  right: 20px;
  background: #4ade80;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transform: translateX(${props => props.show ? '0' : '100%'});
  opacity: ${props => props.show ? '1' : '0'};
  transition: all 0.3s ease-in-out;
  max-width: 300px;
  word-wrap: break-word;
  
  &::before {
    content: '✓';
    margin-right: 8px;
    font-weight: bold;
  }
  
  @media (max-width: 768px) {
    top: 20px;
    right: 20px;
    left: 20px;
    max-width: none;
    text-align: center;
  }
`;

export const ParseFailedModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  
  .modal-content {
    background: white;
    border-radius: 16px;
    padding: 32px;
    max-width: 480px;
    width: 90%;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    position: relative;
    
    .close-button {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 6px;
      border-radius: 6px;
      color: #6b7280;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &:hover {
        background: #f3f4f6;
        color: #374151;
      }
    }
    
    .modal-icon {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      
      svg {
        width: 48px;
        height: 48px;
        color: #f59e0b;
        stroke-width: 2;
      }
    }
    
    h3 {
      font-size: 20px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0 0 16px 0;
      text-align: center;
    }
    
    p {
      color: #6c757d;
      margin: 0 0 24px 0;
      line-height: 1.6;
      font-size: 14px;
      text-align: center;
    }
    
    .suggestions {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 24px;
      
      .suggestion-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 12px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .suggestion-icon {
          color: #6366f1;
          flex-shrink: 0;
          margin-top: 2px;
        }
        
        .suggestion-text {
          font-size: 14px;
          color: #495057;
          line-height: 1.5;
        }
      }
    }
    
    .button-group {
      display: flex;
      gap: 12px;
      justify-content: center;
      
      button {
        padding: 10px 24px;
        border-radius: 8px;
        border: none;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 14px;
        
        &.primary {
          background: #6366f1;
          color: white;
          
          &:hover {
            background: #4f46e5;
          }
        }
      }
    }
  }
`;
